import { render, staticRenderFns } from "./AdminNavigation.vue?vue&type=template&id=c1b15024"
import script from "./AdminNavigation.vue?vue&type=script&lang=js"
export * from "./AdminNavigation.vue?vue&type=script&lang=js"
import style0 from "./AdminNavigation.vue?vue&type=style&index=0&id=c1b15024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports